import { render, staticRenderFns } from "./AllRetailer.vue?vue&type=template&id=381d5036&scoped=true"
import script from "./AllRetailer.vue?vue&type=script&lang=js"
export * from "./AllRetailer.vue?vue&type=script&lang=js"
import style0 from "./AllRetailer.vue?vue&type=style&index=0&id=381d5036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381d5036",
  null
  
)

export default component.exports